import React from "react";

const TABS = ["Overview", "Revenue", "Patient", "Prescriptions", "Diagnoses", "Accounting"] as const;
export type DashboardTab = typeof TABS[number];

interface Props {
  active: DashboardTab;
  onChange: (tab: DashboardTab) => void;
}

export const DashboardTabs: React.FC<Props> = ({ active, onChange }) => (
  <div className="bg-white rounded-2xl border border-slate-100 shadow-sm px-2 py-2 flex items-center gap-1 overflow-x-auto">
    {TABS.map((tab) => {
      const isActive = tab === active;
      return (
        <button
          key={tab}
          onClick={() => onChange(tab)}
          className={`flex-1 min-w-[100px] min-h-[44px] text-sm font-medium px-4 py-2 rounded-xl transition-colors whitespace-nowrap ${
            isActive
              ? "bg-blue-600 text-white shadow-sm"
              : "text-slate-600 hover:bg-slate-50"
          }`}
        >
          {tab}
        </button>
      );
    })}
  </div>
);

export default DashboardTabs;
